import { Injectable, inject, signal } from '@angular/core';
import { VenueService } from './venue.service';
import { MyVenueResponse } from '../../shared/models/venue.models';

@Injectable({ providedIn: 'root' })
export class VenueStateService {
  private readonly venueService = inject(VenueService);

  readonly activeVenue = signal<MyVenueResponse | null>(null);
  readonly venues = signal<MyVenueResponse[]>([]);
  readonly loading = signal(false);
  readonly error = signal<string | null>(null);

  private initialized = false;

  init(): void {
    if (this.initialized) return;
    this.initialized = true;
    this.loading.set(true);

    this.venueService.getMyVenues().subscribe({
      next: (res) => {
        this.loading.set(false);
        if (res.success && res.data?.length > 0) {
          this.venues.set(res.data);
          this.activeVenue.set(res.data[0]);
        } else {
          this.error.set('Tu cuenta no tiene bares asociados. Contacta a soporte.');
        }
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Error al cargar la información del bar. Intenta de nuevo.');
      },
    });
  }

  setActive(venue: MyVenueResponse): void {
    this.activeVenue.set(venue);
  }

  reset(): void {
    this.initialized = false;
    this.activeVenue.set(null);
    this.venues.set([]);
    this.error.set(null);
    this.loading.set(false);
  }
}
